"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _overlay = _interopRequireDefault(require("@waglabs/overlay"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Overlay = function Overlay() {
  return _reactDom["default"].createPortal(_react["default"].createElement(_overlay["default"], null), document.body);
};

exports.Overlay = Overlay;